import {DateTime} from "luxon";


export class Invoice {
  id: number;

  bankAccountId: number;

  invoiceNumber: string;

  ownerCode: string;

  moneyOwner: string;

  customerName: string;

  moneyOwnerDisplay: string;

  customerNameDisplay: string;

  startingDate: DateTime;

  endDate: DateTime;

  amount: number;

  currency: string;

  invoiceState: Invoice.InvoiceState;

  creationDate: DateTime;

  dueDate: DateTime;

  outStandingAmount: number;

  soldOutAmount: number;

  settlementDate: DateTime = DateTime.fromMillis(1000);

  lateDays: number = 0;

  invoiceSettlementState: string = Invoice.InvoiceSettlementState.NONE;

  year: number;

  dutyFreeAmount: number;

  vatAmount: number;

  vatRate: number
  lastRecall: DateTime;

  ownerCurrencyAmount: number;

  ownerCurrencyOutstandingAmount: number;

  ownerCurrencysoldoutAmount: number;

  contractUnit: string;

  modifiedDate: DateTime;

  operator: string;

  needAttention: boolean;

}

export module Invoice {
  export enum InvoiceState {
    UNPAID = 'UNPAID',
    PART_PAID = 'PART_PAID',
    FULLY_PAID = 'FULLY_PAID',
    CANCELLED = 'CANCELLED',
    ON_HOLD = 'ON_HOLD',
    INVALID = 'INVALID',
    UNBILLED = 'UNBILLED'
  }

  export enum InvoiceSettlementState {
    NONE = 'NONE',
    LATE = 'LATE',
    ONTIME = 'ONTIME',
    SOLDOUT = 'SOLDOUT'
  }
}
